import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSocialAccountContentThunk } from 'slices/socialAccounts/thunk';
import { RootState, AppDispatch } from 'store';
import { generateUniqueKey } from 'utils/helpers';
import PostCard from '../PostCard';
import Skeleton from 'react-loading-skeleton';
import SocialPostModal from '../SocialPostModal';
import { closeSocialPostModal } from 'slices/ui/reducer';
import SmartImage from 'Components/Common/SmartImage';
import ContentMasonry from '../ContentMasonry';

const SocialAccountContent: React.FC<{ socialAccountId: string }> = ({ socialAccountId }) => {

    const socialPostModal = useSelector((state: RootState) => state.ui.socialPostModal);
    const filters = useSelector((state: RootState) => state.socialAccountState.content.filters);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const [filtersId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const loading = useSelector((state: RootState) => state.socialAccountState.content.loading);
    const error = useSelector((state: RootState) => state.socialAccountState.content.loading);


    const postsData = useSelector((state: RootState) => state.socialAccountState.content.items[socialAccountId!]?.filtered_lists?.[filtersId!]);
    const posts = postsData?.items ?? [];
    const has_more = postsData?.has_more ?? true;
    const page = postsData?.page ?? 1;


    const [initialLoading, setInitialLoading] = useState(true);


    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if (socialAccountId && filters) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchSocialAccountContentThunk({ socialAccountId, filters })).finally(() => {
                    setInitialLoading(false);
                    setFilterId(generateUniqueKey(filters, ['page']))
                })
            }, 500)
        }
    }, [socialAccountId, filters])

    const nextPage = () => {
        if (has_more && socialAccountId && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialAccountContentThunk({ filters: { ...filters, page: nextPageNumber }, socialAccountId }))
        }
    }

    return (
        <>
            <div className='pb-5'>
                <InfiniteScroll
                    dataLength={posts.length}
                    next={nextPage}
                    className=""
                    hasMore={has_more}
                    loader={<></>}
                >
                    <ContentMasonry posts={posts.map((p) => p.social_post)} isLoading={loading || initialLoading} />
                </InfiniteScroll>


                {
                    !(loading || initialLoading) && (posts.length === 0) &&
                    <div className="d-flex w-100 justify-content-center align-items-center">
                        <div className="length-zero">
                            <h3>Currently there is no post in your list, try adjusting filters!</h3>
                        </div>
                    </div>
                }
            </div>
            <SocialPostModal
                isOpen={!!socialPostModal}
                onClose={() => dispatch(closeSocialPostModal())}
                socialAccount={socialPostModal?.socialAccount}
                postId={socialPostModal?.postId}
                disableComments={true}
            />
        </>
    )
}

export default SocialAccountContent
